import Icon from './Icon'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class OverlayTileHeading extends PureComponent {
  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string
  }

  render() {
    const { icon, title } = this.props

    return (
      <div className="editor-section-title">
        {icon && <Icon name={this.props.icon} />}
        {I18n.t(title)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayTileHeading.js